require('../modules/web.timers');
require('../modules/web.immediate');
require('../modules/web.dom.iterable');
module.exports = require('../modules/_core');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/web/index.js
// module id = 758
// module chunks = 8